import { useMediaQuery } from "@mui/material";
import "./Footer.scss";

function Footer() {
  // Use a media query to check if the screen width is less than 600px
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  // If it's a small screen, don't render the footer
  if (isSmallScreen) {
    return null;
  }

  return (
    <div className="footer">
      <span>Purity Nail Bar - John Phan</span>
      <span> © 2024 Ezsalon.</span>
    </div>
  );
}

export default Footer;
